import { endOfMonth, startOfMonth, subMonths } from "date-fns";
import { formatDateForInput } from "@/shared/lib/date-time";

export function hasReportShiftFilter(shiftIds: string | undefined): boolean {
  return (
    (shiftIds
      ?.split(",")
      .map((s) => s.trim())
      .filter(Boolean).length ?? 0) > 0
  );
}

export function defaultPosReportDateRangeIso(): {
  dateFrom: string;
  dateTo: string;
} {
  const from = startOfMonth(subMonths(new Date(), 0));
  const to = endOfMonth(new Date());
  return {
    dateFrom: `${formatDateForInput(from)}T00:00:00Z`,
    dateTo: `${formatDateForInput(to)}T23:59:59Z`,
  };
}

export function monthRangeIsoFromInputMonth(yyyyMm: string): {
  dateFrom: string;
  dateTo: string;
} | null {
  const match = /^(\d{4})-(\d{2})$/.exec(yyyyMm.trim());
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  if (month < 1 || month > 12) return null;
  const from = new Date(year, month - 1, 1);
  const to = endOfMonth(from);
  return {
    dateFrom: `${formatDateForInput(from)}T00:00:00Z`,
    dateTo: `${formatDateForInput(to)}T23:59:59Z`,
  };
}

export function monthValueFromDateFromIso(dateFrom: string): string {
  const d = new Date(dateFrom);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
}
